/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconMergeTag.vue?vue&type=template&id=39af3571"
import script from "./IconMergeTag.vue?vue&type=script&lang=js"
export * from "./IconMergeTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39af3571')) {
      api.createRecord('39af3571', component.options)
    } else {
      api.reload('39af3571', component.options)
    }
    module.hot.accept("./IconMergeTag.vue?vue&type=template&id=39af3571", function () {
      api.rerender('39af3571', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconMergeTag.vue"
export default component.exports